import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../hooks/hooks";
import Table from "../../../../common/components/table";
import PageLoader from "../../../../components/PageLoader";
import { useNavigate } from "react-router-dom";
import { globalCatalog } from "../../../../redux/global-catalog/action";
import { selectGlobalCatalogListItems } from "../../../../redux/global-catalog/selector";



const GlobalCatalogInfoComponent = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
    const globalCatalogItems = useSelector(selectGlobalCatalogListItems)
    const [storedItems, setStoredItems] = useState<any>({});

  useEffect(() => {
      const storedValue = localStorage.getItem('storageKey');
      if (storedValue) {
          try {
              const parsedValue = JSON.parse(storedValue);
              setStoredItems(parsedValue.items || []);
          } catch (error) {
              console.error("Error parsing JSON from localStorage:", error);
          }
      } else {
          console.log("No stored value found");
      }
  }, []);
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          {
            field: 'Image',
            headerName: 'Image',
            sortable: false,
            filter: false,
            cellRenderer: 'imageRenderer',
          },
          {
            field: 'Name',
            headerName: 'Name',
            sortable: true,
            filter: true,
          },
          {
            field: 'Price',
            headerName: 'Price',
            sortable: true,
            isCurrencyValueFormat: true,
          },
          { field: 'StockQuantity', headerName: 'StockQuantity' },
          {
            field: 'IsPublished',
            headerName: 'Published',
            cellRenderer: 'yesNoRenderer',
          },
          {
            field: 'VendorName',
            headerName: 'Vendor',
            sortable: true,
          },
          {
            field: 'CreatedOnUtc',
            headerName: 'Created On',
            isDateValueFormat: true,
            sortable: true,
          },
       
        ]);
      }

      const fetchGlobalCatalog=()=>{
        dispatch(globalCatalog.list({url:`https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/catalog-collections/global/fetch-catalog`,entity:'globalCatalog',jsonData:{
          "Context": {
						"Subscription": "DBaasEdgenet",
						"Domain": "EdgeNet",
						"SubDomains": [],
						"Network": "Internal",
						"Application": "DBN",
						"Channel": "CSP"
					},
          "Records": [
              {
                "IsDBNBased":  true,
                "DBNIEId": storedItems?.DBNIEId
              }
          ],
          "Pagination": {
        
          }
        }}))
      }
      const handleAdd=()=>{
        navigate(`${0}`)
      }
    
      useEffect(() => {
        console.log("Fetched policyItems:", globalCatalogItems);
      }, [globalCatalogItems]);
      const formatRowData = () => {
        if (!Array.isArray(globalCatalogItems?.result?.items)) {
          return [];
        }
      
        return globalCatalogItems.result.items.flatMap((item: any) => {
        return item.Products?.map((product: any) => ({
              Id: product?.Id,
              Name: product?.Name || "",
              VendorName: product?.VendorName || "",
              Price: product?.Price || "",
              IsPublished: product?.IsPublished || "",
              StockQuantity: product?.StockQuantity || 0,
              Image: product?.MediaMappings?.MediaFiles?.[0]?.FileMappingURL || "",
              CreatedOnUtc: product?.CreatedOnUtc || "",
            })) || [];
        });
      };
      const handleSearch = (data: any) => {
        console.log('Search data', data)
        let searchCriteria = {};
        if (data?.column){
          searchCriteria = [{
            FieldName: data?.column,
            FieldText: data?.column,
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        } else {
          searchCriteria = [{
            FieldName: "Name",
            FieldText: "Name",
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        }
    
        dispatch(globalCatalog.list({url:`https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/catalog-collections/global/fetch-catalog`,entity:'globalCatalog',jsonData:{
          "Pagination": {
         },
         "Context": {
          "Subscription": "DBaasEdgenet",
          "Domain": "EdgeNet",
          "SubDomains": [],
          "Network": "Internal",
          "Application": "DBN",
          "Channel": "CSP"
        },
          "Records": [
              {
                "IsDBNBased":  true,
                "DBNIEId": storedItems?.DBNIEId
              }
          ],
       
    
          }}))
      }
    
      const handleReloadData = () => {
        dispatch(globalCatalog.list({url:`https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/catalog-collections/global/fetch-catalog`,entity:'globalCatalog',jsonData:{
          "Context": {
						"Subscription": "DBaasEdgenet",
						"Domain": "EdgeNet",
						"SubDomains": [],
						"Network": "Internal",
						"Application": "DBN",
						"Channel": "CSP"
					},
          "Records": [
              {
                "IsDBNBased":  true,
                "DBNIEId": storedItems?.DBNIEId
              }
          ],
          "Pagination": {
          
          }
          }}))
      }
      const filterTypes = [{
        name: 'Text', value: "text"
      },
      {
        name: 'Number', value: "number"
      },
      {
        name: 'CheckBox', value: "checkbox"
      },
      {
        name: 'Date', value: "date"
      }
      ]
      const additionButtons: any = [
        {
          svg:
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload</title>
          <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
        // name: 'Reload',
        callback: () => handleReloadData(),
        },
      ];

	useEffect(() => {
    if(storedItems?.Id){
        createColumnDefs()
        fetchGlobalCatalog()
    }
	}, [pageData,pageSize,storedItems])

  const handleDelete=(data: any)=>{
    dispatch(globalCatalog.delete({
      url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/catalog-collections/global/delete`,
      entity: 'globalCatalog',
      jsonData: {
        Records: [
          {
         
                Id: data?.Id
            }
          
        ]
      }
  })).then(() => {
    dispatch(globalCatalog.list({url:`https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/catalog-collections/global/fetch-catalog`,entity:'globalCatalog',jsonData:{
      "Context": {
        "Subscription": "DBaasEdgenet",
        "Domain": "EdgeNet",
        "SubDomains": [],
        "Network": "Internal",
        "Application": "DBN",
        "Channel": "CSP"
      },
          "Records": [
              {  "IsDBNBased":  true,
                "DBNIEId": storedItems?.DBNIEId
              }
          ],
          "Pagination": {
         
          }
    }}))
  });
  }
	return (
    <>
    {globalCatalogItems?.isLoading ?  <PageLoader />: 
		<Table columnData={columnDefs} additionButtons={additionButtons}enableFilter={true}
    filterTypeLists={filterTypes}
    onSearch={handleSearch}rowData={formatRowData()} setPageData={setPageData}
    paginationData={globalCatalogItems?.result?.pagination}
  setPageSize={setPageSize}headingName="Global Catalog"/>
     
  }
  </> 
	);
};

export default GlobalCatalogInfoComponent;


